// {token} replacement for showcase copy rendered as page text.
export const formatShowcaseCopy = (template, values = {}) => String(template || '').replace(
  /\{(\w+)\}/g,
  (match, key) => (Object.prototype.hasOwnProperty.call(values, key) ? String(values[key]) : match)
);

// Headlines carry [[accent]] markers for the reels; page text drops them.
export const stripShowcaseAccent = (text) => String(text || '').replace(/\[\[(.+?)\]\]/g, '$1');
